import { defineComponent as _defineComponent } from 'vue'
import BaseTable from "@/components-UI/table/BaseTable.vue";
import { useBills } from "@/services/TablePage/bills";
import { onMounted, ref, watchEffect } from "vue";
import { FormattedItem } from "@/utils/CellsFromBff";
import { Bill } from "@/api/types/payout";
import { getBillsList } from "@/api/payout";
import { showServerError } from "@/utils";
import { storeToRefs } from "pinia";
import { useBillsStore } from "@/store_v3/BillsStore";
import store from "@/store";
import { useRoute } from "vue-router/composables";
import { updateQueryString } from "@/utils/updateQueryString";

interface Props {
    isDetail?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BillsTable',
  props: {
    isDetail: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as {
    isDetail?: boolean
}




const route = useRoute();
const { getHeaders } = useBills(props.isDetail);
const { isNeedUpdateBills } = storeToRefs(useBillsStore());
const items = ref<FormattedItem<Bill>[]>([]);
const total = ref(0);
const offset = ref(0);
const isLoading = ref(false);

onMounted(() => {
    getBills();
});

watchEffect(() => {
    if (isNeedUpdateBills.value) {
        changePage(0);
        isNeedUpdateBills.value = false;
    }
});

const changePage = (offsetValue: number) => {
    offset.value = offsetValue;
    getBills();
};

const getBills = async () => {
    try {
        isLoading.value = true;
        const params = props.isDetail ? { invoice_ids: [route.params.id] } : getParams();
        const { data, meta } = await getBillsList(params);
        total.value = meta?.total;
        items.value = data;
    } catch (err) {
        showServerError(err, 'Список платежей не загружен');
    } finally {
        isLoading.value = false;
        if (!props.isDetail) {
            const currentQuery = route.query;
            updateQueryString({ ...currentQuery, ...getParams() });
        }
    }
};

const getParams = () => {
    const params = { ...store.getters['GET_FILTERS_PARAMS_OBJECT'] };
    params.offset = offset.value;
    params.limit = 100;
    return params;
};

expose({
    getBills,
    getParams,
});

return { __sfc: true,props, route, getHeaders, isNeedUpdateBills, items, total, offset, isLoading, changePage, getBills, getParams, BaseTable }
}

})